// frontend/src/authConfig.js
export const msalConfig = {
    auth: {
        clientId: "3d31f13c-7bc2-4c21-b5d3-1b297a74a588", // <--- No dejes texto de ejemplo
        authority: "https://login.microsoftonline.com/e6f7a1ea-f9c7-4188-a892-09d939641808",
        redirectUri: "https://as400.atlanticu.edu",
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ["User.Read"],
};